import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  reportConfigurations: [],
  isLoadingReportConfigurations: false,
  reportGenerateTypes: [],
  isLoadingReportGenerateTypes: false,
  reportTypes: [],
  isLoadingReportTypes: false,
  reportConfigurationDetails: {},
  isLoadingReportConfigById: true,
  isLoading: false,
  error: null,
};

export const getReportConfigurations: any = createAsyncThunk(
  "content/getReportConfigurations",
  async ({ PageNumber, pageSize, searchText, SortBy, SortDirection }: any) => {
    const res = await axios.get(`/slpapp/ReportConfiguration/getall`, {
      params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    });

    const data = await res.data;
    return data;
  }
);

export const getReportGenerateTypes: any = createAsyncThunk(
  "content/getReportGenerateTypes",
  async () => {
    const res = await axios.get(`/slpapp/ReportGenerateType`);

    const data = await res.data;
    return data;
  }
);

export const getReportTypes: any = createAsyncThunk(
  "content/getReportTypes",
  async () => {
    const res = await axios.get(`/slpapp/ReportType`);

    const data = await res.data;
    return data;
  }
);

export const getReportConfigurationsById: any = createAsyncThunk(
  "content/getReportConfigurationsById",
  async ({ reportConfigurationId }: any) => {
    const res = await axios.get(
      `/slpapp/ReportConfiguration/ByReportConfigId`,
      {
        params: { reportConfigurationId },
      }
    );

    const data = await res?.data?.data;
    return data;
  }
);

export const addReportConfig: any = createAsyncThunk(
  "content/addReportConfig",
  async ({ payload }: any) => {
    const res = await axios.post(`/slpapp/ReportConfiguration`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const editReportConfig: any = createAsyncThunk(
  "content/editReportConfig",
  async ({ payload, reportConfigurationId }: any) => {
    const res = await axios.put(`/slpapp/ReportConfiguration`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      params: { reportConfigurationId },
    });

    const data = await res.data;
    return data;
  }
);

export const deleteReportConfig: any = createAsyncThunk(
  "content/deleteReportConfig",
  async ({ reportConfigurationId }: any) => {
    const res = await axios.delete(`/slpapp/ReportConfiguration`, {
      params: { reportConfigurationId },
    });

    const data = await res.data.data;
    return data;
  }
);

export const reportConfigurationSlice = createSlice({
  name: "reportConfiguration",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getReportConfigurations.pending, (state) => {
      state.isLoadingReportConfigurations = true;
    });
    builder.addCase(getReportConfigurations.fulfilled, (state, action) => {
      state.isLoadingReportConfigurations = false;
      state.reportConfigurations = action.payload;
    });
    builder.addCase(getReportConfigurations.rejected, (state, action) => {
      state.isLoadingReportConfigurations = false;
      state.error = action.error.message;
    });

    builder.addCase(getReportConfigurationsById.pending, (state) => {
      state.isLoadingReportConfigById = true;
    });
    builder.addCase(getReportConfigurationsById.fulfilled, (state, action) => {
      state.isLoadingReportConfigById = false;
      state.reportConfigurationDetails = action.payload;
    });
    builder.addCase(getReportConfigurationsById.rejected, (state, action) => {
      state.isLoadingReportConfigById = false;
      state.error = action.error.message;
    });

    builder.addCase(getReportGenerateTypes.pending, (state) => {
      state.isLoadingReportGenerateTypes = true;
    });
    builder.addCase(getReportGenerateTypes.fulfilled, (state, action) => {
      state.isLoadingReportGenerateTypes = false;
      state.reportGenerateTypes = action.payload;
    });
    builder.addCase(getReportGenerateTypes.rejected, (state, action) => {
      state.isLoadingReportGenerateTypes = false;
      state.error = action.error.message;
    });

    builder.addCase(getReportTypes.pending, (state) => {
      state.isLoadingReportTypes = true;
    });
    builder.addCase(getReportTypes.fulfilled, (state, action) => {
      state.isLoadingReportTypes = false;
      state.reportTypes = action.payload;
    });
    builder.addCase(getReportTypes.rejected, (state, action) => {
      state.isLoadingReportTypes = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteReportConfig.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteReportConfig.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteReportConfig.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(addReportConfig.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addReportConfig.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addReportConfig.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(editReportConfig.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editReportConfig.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(editReportConfig.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export default reportConfigurationSlice.reducer;
